import styled, { css } from 'styled-components';

const ButtonToggle = styled.button`
  ${({ theme }) => theme.fontFamily.mainFont.xSmallExtraBold}
  height: 100%;
  transition: background-color 0.8s;
  border-radius: 25px;
  background: transparent;
  border: none;
  flex: 0 0 50%;
  z-index: 1;
  color: ${({ theme, active }) =>
    active ? theme.colors.white : theme.colors.night_blue_1};
  ${({ relative }) =>
    relative &&
    css`
      position: relative;
    `}
`;

export default ButtonToggle;
